import React, { useEffect, useState } from 'react';
import SurveyHeaderForm from './SurveyHeaderForm';
import { getAllSurveyHeaders, getSurveyHeader, deleteSurveyHeader } from "../apicalls/surveyHeaders";
import "../main/PopupForm/style/PopupForm.css"; 

import { isAuthenticated } from '../apicalls/auth';
function SurveyHeaders() {
    const [surveyHeaders, setSurveyHeaders] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [currentHeader, setCurrentHeader] = useState(null);
    const [expandedHeader, setExpandedHeader] = useState(null);
    const user = isAuthenticated();

    useEffect(() => {
        const fetchSurveyHeaders = async () => {
            const headers = await getAllSurveyHeaders(user.access_token);
            setSurveyHeaders(headers);
        };
        fetchSurveyHeaders();
    }, [showForm, user.access_token]);

    const handleAddEdit = async (header) => {
        if (!header) {
            setCurrentHeader(null);
            setShowForm(true);
            return;
        }

        const fullHeader = await getSurveyHeader(header.id, user.access_token);
        setCurrentHeader(fullHeader || header);
        setShowForm(true);
    };

    const handleDelete = async (id) => {
        await deleteSurveyHeader(id,user.access_token);
        setSurveyHeaders(surveyHeaders.filter(header => header.id !== id));
    };

    const toggleExpand = (id) => {
        setExpandedHeader(expandedHeader === id ? null : id);
    };

    return (
        <div className="container mt-3">
            <button className="btn btn-primary" onClick={() => handleAddEdit(null)}>Add Survey Header</button>
            {surveyHeaders.map(header => (
                <div key={header.id} className="card mt-2">
                    <div className="card-header" onClick={() => toggleExpand(header.id)}>
                        <h5 className="mb-0">{header.survey_name} {expandedHeader === header.id ? ' [-]' : ' [+]'}
                        </h5>
                    </div>
                    {expandedHeader === header.id && (
                        <div className="card-body">
                            <p><strong>Instructions:</strong> {header.instructions}</p>
                            <button className="btn btn-info" onClick={() => handleAddEdit(header)}>Edit</button>
                            <button className="btn btn-danger" onClick={() => handleDelete(header.id)}>Delete</button>
                        </div>
                    )}
                </div>
            ))}
            {showForm && (
                <SurveyHeaderForm
                    header={currentHeader}
                    onSave={() => setShowForm(false)}
                    onCancel={() => setShowForm(false)}
                />
            )}
        </div>
    );
}

export default SurveyHeaders;
